import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { GoogleSignIn } from '@capawesome/capacitor-google-sign-in';
import { useAuth } from '../context/AuthContext';
import { useNotification } from '../context/NotificationContext';
import { Capacitor } from '@capacitor/core';



const GoogleLoginButton = ({ role, onSuccess }) => {
    const { googleLogin, setAuthFromCodeExchange } = useAuth();
    const { showError } = useNotification();

    const isNative = Capacitor.isNativePlatform();

    const handleToken = async (idToken) => {
        try {
            const result = await googleLogin(idToken, role);
            if (result.success) {
                if (onSuccess) onSuccess(result.user);
            } else {
                showError(result.message || 'Google login failed');
            }
        } catch (error) {
            console.error('Google Login Error:', error);
            showError('Google login failed. ' + (error.message || 'Please try again.'));
        }
    };

    const webLogin = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: async (response) => {
            const result = await setAuthFromCodeExchange({
                code: response.code,
                redirect_uri: window.location.origin,
                role: role || 'patient',
            });
            if (result.success) {
                if (onSuccess) onSuccess(result.user);
            } else {
                showError(result.message || 'Google login failed');
            }
        },
        onError: () => {
            showError('Google login initialization failed. Check network or configuration.');
        },
    });

    const handleNativeLogin = async () => {
        try {
        await GoogleSignIn.initialize({ clientId: '375131968832-j5dl1762578v20ha5no7189oia30dpvu.apps.googleusercontent.com' });
            const result = await GoogleSignIn.signIn();
            // Handle different result structures from different plugin versions
            const idToken = result.idToken || result.authentication?.idToken || result.serverAuthCode;
            if (!idToken) {
                showError('No ID token received from Google. Please try again.');
                return;
            }
            await handleToken(idToken);
        } catch (error) {
            console.error('Native Google Sign-In Error:', JSON.stringify(error));
            const msg = error.message || '';
            if (msg && !msg.includes('cancel') && !msg.includes('SIGN_IN_CANCELED') && !msg.includes('12501')) {
                showError('Google sign-in failed. Please ensure your iOS URL Scheme (reversed client ID) is added in Xcode Info.plist. Error: ' + msg);
            }
        }
    };

    const handleClick = () => {
        if (isNative) {
            handleNativeLogin();
        } else {
            webLogin();
        }
    };

    return (
        <div className="w-full flex justify-center">
            <button
                onClick={handleClick}
                className="w-full flex items-center justify-center gap-2 bg-white text-gray-700 h-[50px] rounded-lg font-semibold hover:bg-gray-50 transition-colors border border-gray-300 shadow-sm"
            >
                <img src="https://www.svgrepo.com/show/475656/google-color.svg" className="w-5 h-5 mb-0.5" alt="Google" />
                <span>Continue with Google</span>
            </button>
        </div>
    );
};

export default GoogleLoginButton;
